import React from "react";

const Component = () => (
  <div data-testid="placeholder">
    <h1>Invoices</h1>
    <p>Invoices overview.</p>
  </div>
);

export default Component;

